import * as React from "react";
import Backdrop from "@mui/material/Backdrop";
import CircularProgress from "@mui/material/CircularProgress";
import LoadService from "./LoadService";

type LoaderProps = {
  isOpen?: boolean;
};

function Loader({isOpen = false}: LoaderProps) {
  const [open, setOpen] = React.useState<boolean>(isOpen);

  LoadService.subject().subscribe({
    next: (open) => {
      setOpen(open);
    },
  });

  return (
    <Backdrop data-cy="globalLoader" sx={{color: "#fff", zIndex: (theme) => theme.zIndex.modal + 1}} open={open}>
      <CircularProgress color="inherit" />
    </Backdrop>
  );
}

export default Loader;
